import { GetStaticPathsResult, GetStaticPropsContext } from 'next';

import { getAllBlogPostsByDate } from '../../../src/api/contentful/blog/getAllBlogPostsByDate';
import { BLOG_POSTS_PER_PAGE, BLOG_POSTS_PREBUILD_PAGES } from '../../../src/constants/constants';
import { NOT_FOUND_WITH_REVALIDATION, REVALIDATE } from '../../../src/constants/next';
import { reportMykissClientError } from '../../../src/helpers/errorHandling/client';
import { toNumber } from '../../../src/helpers/strings/toNumber';
import { getBlogPostsUrl } from '../../../src/helpers/urls';
import { StaticResult } from '../../../src/interfaces/nextjs';
import { BlogPosts, IBlogPostsProps } from '../../../src/views/Blog/BlogPosts/BlogPosts';

type Params = {
  page: string;
};

export async function getStaticProps({
  params,
}: GetStaticPropsContext<Params>): StaticResult<IBlogPostsProps> {
  try {
    const page = toNumber(params?.page);
    if (!page) {
      return { notFound: true };
    }

    const { items, total } = await getAllBlogPostsByDate(page, BLOG_POSTS_PER_PAGE);

    if (page > Math.ceil(total / BLOG_POSTS_PER_PAGE)) {
      return {
        redirect: {
          destination: '/blog',
          permanent: false,
        },
      };
    }

    return {
      props: {
        _page: 'blog',
        _pageTitle: 'Blog',
        posts: items,
        page,
        endPage: Math.ceil(total / BLOG_POSTS_PER_PAGE),
        canonicalPath: getBlogPostsUrl(page),
        type: 'all',
      },
      revalidate: REVALIDATE.HOURLY,
    };
  } catch (error) {
    reportMykissClientError(error);
    return NOT_FOUND_WITH_REVALIDATION;
  }
}

export async function getStaticPaths(): Promise<GetStaticPathsResult<Params>> {
  const pages = Array.from(
    { length: BLOG_POSTS_PREBUILD_PAGES },
    (_, page): Params => ({ page: page.toString() }),
  );

  return {
    paths: pages.map(params => ({ params })),
    fallback: 'blocking',
  };
}

export default BlogPosts;
